<template>
  <div class="showentries mb-3">
    <label
      >Show
      <app-select
        class="page-size-select"
        v-model="size"
        :options="pageSizes"
        :searchable="false"
        @change="handlePageSizeChange"
      />
      entries
    </label>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  emits: ["page-size-changed"],
  props: ["allowedAll", "defaultPageSize"],
  data() {
    return {
      size: String(this.defaultPageSize || 10),
      pageSizes: ["10", "25", "50", "100"],
    };
  },
  methods: {
    ...mapActions({
      updatePageSize: "theme/updatePageSize",
      updatePagination: "theme/updatePagination",
    }),
    handlePageSizeChange(ev) {
      this.$emit("page-size-changed", ev.target.value);
      // console.log("ev", ev.target.value)
      // if (Number(ev.target.value)) {
      //     this.updatePageSize(Number(ev.target.value))
      // }
    },
  },
  mounted() {
    this.$emit("page-size-changed", this.defaultPageSize || 10);
  },
  unmounted() {
    this.updatePagination({
      current: 1,
      pageSize: 10,
      showSizeChanger: false,
      total: 0,
    });
  },

  // handleTableChange(pagination) {

  //   this.pagination = {
  //     ...pagination,
  //     current: pagination.current,
  //     pageSize: pagination.pageSize,
  //   };
  // },
};
</script>

<style scoped>
.page-size-select {
  display: inline-block;
  width: 90px;
  vertical-align: middle;
}
</style>
